import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonAsync } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	slim?: boolean
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
}

export const Outline = styled(ButtonAsync)<Props>`
	color: ${({ type = 'primary', theme }) => theme.color[type]};
	background-color: transparent;
	border: 1px solid ${({ type = 'primary', theme }) => theme.color[type]};
	font-family: ${helpers.font.family.header};
	font-size: ${({ slim, theme }) => (slim ? theme.font.size.small : theme.font.size.large)};
	line-height: ${({ slim, theme }) => (slim ? theme.font.size.small : theme.font.size.large)};
	margin: 0;

	width: ${({ fullWidth }) => fullWidth && '100%'};
	border-radius: 12px;
	min-width: ${({ slim }) => (slim ? 70 : 140)}px;
	height: ${({ slim }) => (slim ? 28 : 40)}px;
	padding-left: ${({ slim }) => (slim ? 12 : 30)}px;
	padding-right: ${({ slim }) => (slim ? 12 : 30)}px;
	transition: color 0.2s, background-color 0.2s, border-color 0.2s;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${({ type = 'primary', theme }) => transparentize(0.83, theme.color[type])};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:after {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		background-image: radial-gradient(circle, ${({ type = 'primary', theme }) => theme.color[type]} 16%, transparent 16.01%);
		background-repeat: no-repeat;
		background-position: 50%;
		transform: scale(10, 10);
		opacity: 0;
		transition: transform 0.7s, opacity 0.9s;
	}

	&:active:after {
		transform: scale(0, 0);
		opacity: 0.3;
		transition: 0s;
	}

	&:disabled:after {
		opacity: 0;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		border-color: ${helpers.color.disabled};
		color: ${helpers.color.disabled};
	}
`
